"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var clsx_1 = __importDefault(require("clsx"));

var _1 = require(".");

var styles_1 = require("./styles");

var functions_1 = require("./libUtils/functions");

var interactiveStyles = {
  color: 'inherit',
  textDecoration: 'none',
  marginTop: '0',
  marginBottom: '0',
  paddingTop: '16px',
  paddingBottom: '16px',
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
    cursor: 'pointer'
  }
};

var styles = function styles(_ref) {
  var typography = _ref.typography;
  return styles_1.createStyles({
    datalist: Object.assign(Object.assign({
      display: 'flex',
      flexWrap: 'wrap',
      margin: '1rem 0',
      alignContent: 'flex-start'
    }, typography.body2), {
      '& > *': {
        flexGrow: 1,
        margin: '0.5rem',
        maxWidth: '100%'
      }
    }),
    datalistKey: {
      margin: '0.15rem 0.5rem',
      flexGrow: 0,
      flexShrink: 1,
      textTransform: 'uppercase',
      fontSize: '0.95em',
      letterSpacing: '0.01em',
      fontWeight: 600
    },
    datalistValue: {
      margin: '0.15rem 0.5rem',
      wordBreak: 'break-word'
    },
    datalistLink: {
      '& a': Object.assign({}, interactiveStyles)
    },
    datalistButton: Object.assign({}, interactiveStyles),
    datalistHorizontal: {
      flexWrap: 'nowrap',
      '& > *:last-child': {
        textAlign: 'right'
      }
    },
    datalistVertical: {},
    datalistColumns: {}
  });
};

var DataListItem = function DataListItem(_a) {
  var _ref2;

  var datalist = _a.datalist,
      dataKeyWidth = _a.dataKeyWidth,
      datalistBreakpoint = _a.datalistBreakpoint,
      button = _a.button,
      link = _a.link,
      component = _a.component,
      href = _a.href,
      className = _a.className,
      classes = _a.classes,
      children = _a.children,
      onClick = _a.onClick,
      id = _a.id,
      props = __rest(_a, ["datalist", "dataKeyWidth", "datalistBreakpoint", "button", "link", "component", "href", "className", "classes", "children", "onClick", "id"]);

  var listText = {};
  var listChildren = React.Children.toArray(children);
  listChildren.map(function (child) {
    if ("" + child.type === "" + _1.ListItemText) {
      var _child$props = child.props,
          primary = _child$props.primary,
          secondary = _child$props.secondary;
      listText = {
        primary: primary,
        secondary: secondary
      };
    } else {
      console.warn('Data List: Only <ListItemText /> is supported as a child element.');
    }
  });
  var dataKeyStyle = {};

  switch (datalist) {
    case 'vertical':
      dataKeyStyle = {
        flexBasis: dataKeyWidth + "ch"
      };
      break;

    case 'columns':
      dataKeyStyle = {
        flexBasis: '100%'
      };
      break;

    default:
      dataKeyStyle = {
        flexBasis: 'auto'
      };
      break;
  }

  var dataValueStyle = datalist === 'horizontal' ? {
    flexBasis: 'auto'
  } : {
    flexBasis: "calc((" + datalistBreakpoint + " - 100%) * 999)"
  };
  var ListContent = React.createElement(React.Fragment, null, listText.primary && React.createElement("span", {
    className: classes.datalistKey,
    style: dataKeyStyle
  }, listText.primary), listText.secondary && React.createElement("span", {
    className: classes.datalistValue,
    style: dataValueStyle
  }, listText.secondary));
  var rootClasses = clsx_1.default(className, classes.datalist, typeof datalist === 'string' && classes["datalist" + functions_1.capitalize(datalist)], button && !href && classes.datalistButton);
  var listItemProps = {
    onClick: onClick,
    children: ListContent,
    className: rootClasses
  };

  if (link || href || component === 'a') {
    var LinkComponent = component || 'a';
    var linkProps = Object.assign({
      href: href
    }, listItemProps);
    return React.createElement("li", Object.assign({
      id: id
    }, props, {
      className: classes.datalistLink
    }), React.createElement(LinkComponent, Object.assign({}, linkProps)));
  }

  var buttonProps = button ? (_ref2 = {
    tabIndex: 0,
    role: 'button'
  }, _ref2['aria-disabled'] = false, _ref2) : {};
  var ListComponent = component || 'li';
  return React.createElement(ListComponent, Object.assign({
    id: id
  }, listItemProps, buttonProps));
};

exports.default = styles_1.withStyles(styles, {
  name: 'UnifiDataListItem'
})(DataListItem);